<template>
    <div id="session" class="room__session">
        <div v-show="subscriber && subscriber.id" class="room__main-videobox">
            <div class="room__videobox" ref="subscriber">
                <subscriber v-if="streams.length" :opts="{width: '100%', height: '100%'}"></subscriber>
            </div>
            <div v-if="sessionLoad && windowWidth <= 1000" class="room__main-publisher">
                <publisher :opts="{width: '100%', height: '100%'}"></publisher>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    import Publisher from './Publisher.vue';
    import Subscriber from './Subscriber.vue';

    export default {
        name: 'session',
        components: {
            Publisher,
            Subscriber
        },
        computed: {
            ...mapState('conference', [
                'session',
                'streams',
                'subscriber',
                'sessionLoad'
            ]),
            ...mapState([
                'windowWidth',
                'user'
            ])
        },
        watch: {
            subscriber(subscriber){
                if (subscriber && subscriber.element) {
                    this.$refs.subscriber.appendChild(subscriber.element);
                }
            }
        },
        created() {
            this.getSession();

            this.session.on('streamCreated', (event) => {
                this.setStream(event.stream);
            });

            this.session.on('streamDestroyed', (event) => {
                this.spliceStream(event.stream);
                this.setSubscriber([]);
            });

            this.setSessionLoad(true);

            this.session.on('signal:subscriberElementCreated', ({data}) => {
                if (data.userId !== this.user.id && data.mediaAccess) {
                    setTimeout(() => {
                        if (this.subscriber.length === 0) {
                            return window.location.reload();
                        }
                    }, 2000);
                }
            });
        },
        methods: {
            ...mapActions('conference', [
                'getSession',
                'publish'
            ]),
            ...mapMutations('conference', [
                'setStream',
                'setToken',
                'spliceStream',
                'setSubscriber',
                'setSessionLoad',
                'setUsers'
            ])
        }
    };
</script>

<style>

</style>
